import React, {useState} from 'react';
import GoogleMapReact from 'google-map-react';
import { GOOGLE_MAPS_KEY, GOOGLE_MAPS_MAP_ID } from '../__constants__/apiKeys';

const DEFAULT_CENTER = { lat: 51.5285582, lng: -0.2416803 };

function Map(props) {

    const [center, setCenter] = useState(DEFAULT_CENTER)
    const { address, infoWindowContent, radiusMile, hideCircle, className } = props

    const handleApiLoaded = (map, maps) => {
        const geocoder = new maps.Geocoder();

        if (geocoder) {
            geocoder.geocode({ address }, handleGeocodeResponse(map, maps));
        }
    }

    const handleGeocodeResponse = (map, maps) => async (results, status) => {
        const { AdvancedMarkerElement } = await maps.importLibrary("marker");

        if (status !== maps.GeocoderStatus.OK) {
            console.log('Geocode was not successful for the following reason: ' + status);
            return;
        }
        if (status === maps.GeocoderStatus.ZERO_RESULTS) {
            console.log('No results found');
            return;
        }

        const coords = results[0].geometry.location.toJSON();

        setCenter(coords);

        const marker = new AdvancedMarkerElement({ map, position: coords }); 

        if (infoWindowContent) {
            const infoWindow = new maps.InfoWindow({ content: infoWindowContent });
            marker.addListener('click', function() {
                infoWindow.open(map, marker);
            });
        }

        if (hideCircle) {
            new maps.Circle({
                strokeColor: "#022D4F",
                strokeOpacity: 0.2,
                strokeWeight: 1,
                fillColor: "#0099bc",
                fillOpacity: 0,
                map,
                center: coords,
                radius: radiusMile * 1609.344,
            });
        }
        
    }
        return (
            <div className={`google-map w-full h-[360px] mx-0 my-auto ${className}`}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: GOOGLE_MAPS_KEY }}
                    defaultCenter={ DEFAULT_CENTER }
                    defaultZoom={9}
                    center={center}
                    options={{
                        mapId: GOOGLE_MAPS_MAP_ID,
                        styles: null
                    }}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
                />
            </div>
        );
}

Map.defaultProps = {
    className: '',
    address: 'London, UK',
    radiusMile: 10,
}

export default Map;
